export default __webpack_public_path__ + "static/media/capsicum.54c16530.png";